import { ColorEnum } from '@/constants/color'
import PowerIcon from '@/features/ui/icons/components/PowerIcon'
import { useAppDispatch } from '@/hooks/redux'
import { logoutCurrentProfile } from '@/redux/reducers/auth/actions'
import { FC } from 'react'
import { GestureResponderEvent, Pressable, StyleSheet } from 'react-native'

const ProfileActiveSessionLogoutAction: FC = () => {
    const dispatch = useAppDispatch()

    const handlePress = (event: GestureResponderEvent) => {
        event.stopPropagation()
        dispatch(logoutCurrentProfile())
    }

    return (
        <Pressable onPress={handlePress} style={styles.button}>
            <PowerIcon fill={ColorEnum.WHITE} />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    button: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
        marginRight: 4,
    },
})

export default ProfileActiveSessionLogoutAction
